export class SelecionaEntidadeVO {

  id: number;
  idPessoaJuridicaUnico:number;
  idUnicoPessoaFisica: number;
  anoBase: number;
  cnpj: string;
  razaoSocial: string;
  tipo: string;
  cartaCreditoLiberada: boolean;

}
